// src/components/PackingLists/GroupedView.js
import React from 'react';
import ItemsTable from './ItemsTable';
import { Button } from 'react-bootstrap';

/**
 * GroupedView component to handle displaying items grouped by category or location
 * 
 * @param {Object} props - Component props
 * @param {Array} props.items - List of items to display
 * @param {string} props.groupBy - How to group the items ('none', 'category', 'location')
 * @param {Object} props.collapsedGroups - Which groups are currently collapsed
 * @param {Function} props.toggleGroupCollapse - Function to toggle a group's collapse state
 * @param {Function} props.expandAllGroups - Function to expand all groups
 * @param {Function} props.collapseAllGroups - Function to collapse all groups
 * @param {Object} props.tableProps - Props to pass to the ItemsTable component
 * @returns {JSX.Element} Rendered component
 */
const GroupedView = ({
  items,
  groupBy,
  collapsedGroups,
  toggleGroupCollapse,
  expandAllGroups,
  collapseAllGroups,
  tableProps
}) => {
  // Group items by the specified property (category or location)
  const groupItemsBy = (items, property) => {
    return items.reduce((groups, item) => {
      const key = item[property] || 'Uncategorized';
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(item);
      return groups;
    }, {});
  };

  if (groupBy === 'none' || !items || items.length === 0) {
    return <ItemsTable {...tableProps} items={items || []} />;
  }

  const groups = groupItemsBy(items, groupBy);
  
  return (
    <>
  <div className="d-flex justify-content-end mb-3 gap-2">
    <Button 
      variant="outline-secondary"
      size="sm"
      onClick={expandAllGroups}
    >
      Expand All
    </Button>
    <Button 
      variant="outline-secondary"
      size="sm"
      onClick={() => collapseAllGroups(groups)}
    >
      Collapse All
    </Button>
  </div>
  {Object.keys(groups).sort().map(groupName => (
    <div key={groupName} className="mb-4">
      <ItemsTable 
        {...tableProps} 
        items={groups[groupName]} 
        tableTitle={groupName}
        collapsedGroups={collapsedGroups}
        toggleGroupCollapse={toggleGroupCollapse}
      />
    </div>
  ))}
</>
  );
};

export default GroupedView;